/**
 * Created by RKL on 07/09/2015.
 */
define('adminLisAnaDetailsController',[
  'module',
  'underscore',
  'app',
  'bootbox',
  'adminLisAnaDetailsView',
  'emptyView',
  'lisAnaDetailTabController',
  'rolesMixin',
  'settings',
  'entities/lisanas'
], function(
  module,
  _,
  App,
  bootbox,
  View,
  EmptyView,
  lisAnaDetailTabController
) {
  'use strict';

  var LisAnasDetailsController = {
    fetchLisAna: function(data) {
      var that = this,
          emptyView = new EmptyView(),
          contentRegion = App.regions.getRegion('main').currentView.getRegion('content');

      contentRegion.show(emptyView);

      this.data = data;
      if (this.model && this.model.get('secId') === data.secId) {
        this.showLisAna(data);
      } else {
        this.model = App.request('lisana:model', {secId: data.secId});
        this.model.fetch().done(function() {
          if (contentRegion) {
            that.showLisAna(data);
          }
        });
      }
    },

    showLisAna: function(data) {
      var view = new View({model: this.model, data: data});

      this.view = view;
      data.model = this.model;

      App.regions.getRegion('main').currentView.getRegion('content').show(view);

      this.displayTabs(data);

      view.listenTo(view, 'click:tab', _.bind(this.onTabClick, this));
      view.listenTo(App, 'lisana:header:rerender', _.bind(this.onHeaderChange, this));
    },

    onHeaderChange: function (lisAna) {
      this.view.onHeaderChange(lisAna);
    },

    displayTabs: function(data) {
      lisAnaDetailTabController.showTab(data);
      data.model = this.model;
      this.tab = data.tab;
    },

    onTabClick: function(tab) {
      if (this.data.tab !== tab || this.data.secId) {
        this.data.tab = tab;
        this.data.secId = null;

        this.displayTabs(this.data);
        App.navigate('admin/lisanas/' + this.model.get('secId') + '/' + tab.name);
      }
    }
  };

  module.exports = LisAnasDetailsController;
});
